import { render, staticRenderFns } from "./AsCoachView.vue?vue&type=template&id=f574faf4&scoped=true"
import script from "./AsCoachView.vue?vue&type=script&lang=js"
export * from "./AsCoachView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f574faf4",
  null
  
)

export default component.exports